<div class="form-container">
  <label class="custom-dropdown-label">{{label}} <span *ngIf="this.required">*</span></label>
  <angular2-multiselect position="bottom" [data]="choices" [ngModelOptions]="{ standalone: true }"
    [(ngModel)]="selected" [settings]="settings" (onSelect)="formChanged($event)" (onDeSelect)="formChanged($event)"
    (onSelectAll)="formChangedSelectAll($event)" (onDeSelectAll)="formChangedDeselectAll($event)">

  </angular2-multiselect>
  <mat-error *ngIf="touched && required && (!selected || selected.length === 0)">Field is required</mat-error>
</div>
